import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect } from "react";
import stateContext from "../../Context/StateContext";
import { apiClient } from "../../api/client";
export const LoadMetalData = () => {
    const globalState = useContext(stateContext);
    const metalDataQuery = useQuery({
        queryKey: ["metalData"],
        queryFn: () => apiClient.get("/metals"),
    });
    useEffect(() => {
        if (metalDataQuery.isSuccess) {
            const metalData = metalDataQuery.data?.data || [];
            globalState.setAllMetalData(metalData);
            const firstAvailableIndex = metalData.findIndex(
                (m) => m.status === "Available"
            );
            if (firstAvailableIndex !== -1) {
                const metal = metalData[firstAvailableIndex];
                globalState.setSelectedMetalData(metal);
            }
        }
    }, [metalDataQuery]);
    return null; // This component does not render anything
};
